import { CSSProperties, FC } from 'react';
import logo from './logo.svg';

interface DefaultLogoProps {
  style?: CSSProperties;
}

export const DefaultLogo: FC<DefaultLogoProps> = ({ style }) => (
  <img style={{ minHeight: '100%', ...style }} src={logo} alt="" />
);
